import type { RiskDimension } from "@/api";
import type { TranslationKey } from "@/i18n";

/**
 * Maps each risk dimension enum value to a translation key so
 * dimension labels re-render on a locale switch. Shared by the
 * dashboard, signals, and snapshot views.
 */
export const DIMENSION_KEY: Record<RiskDimension, TranslationKey> = {
  security: "risk.dimensions.security",
  policy: "risk.dimensions.policy",
  asset: "risk.dimensions.asset",
  compliance: "risk.dimensions.compliance",
};
